/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-26 08:00:56
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { Card, Icon } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { QuestionMarkMajor, PlayCircleMajor } from '@shopify/polaris-icons';

import YoutubeModal from 'src/components/views/common/youtube-modal';
import { RenderSuggestionStyle } from './render-suggestion-style';
import { RenderSelect } from 'src/components/views/common/forms/render-select';
import ConfirmModal from '../common/confirm-modal';

import {
  LAYOUT_SUGGESTION_STYLE_LABEL,
  LAYOUT_SUGGESTION_PRODUCT_ITEM_TYPE,
  LAYOUT_SUGGESTION_PRODUCT_POSITION,
  LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE2,
  LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE3
} from 'src/constants/instant-search-display';
import { URL } from 'src/constants/links';
import { getLayoutSettingsImage } from 'src/helpers/instant-search-display-helper';

// Render component
const LayoutSettings = props => {
  const {
    i18n,
    suggestionStyle1ProductItemType,
    suggestionStyle2ProductItemType,
    suggestionStyle2ProductPosition,
    suggestionStyle2ProductPerRow,
    suggestionStyle3ProductItemType,
    suggestionStyle3ProductPosition,
    suggestionStyle3ProductPerRow,
    updateField,
    formValues,
    suggestionBlocks
  } = props;

  const [youtubeModal, setYoutubeModal] = useState(false);
  const [productsItemType, setProductsItemType] = useState([]);
  const [productsPosition, setProductsPosition] = useState([]);
  const [productsPerRowStyle2, setProductsPerRowStyle2] = useState([]);
  const [productsPerRowStyle3, setProductsPerRowStyle3] = useState([]);
  const [activeModalConfirm, setActiveModalConfirm] = useState(false);
  const [styleChange, setStyleChange] = useState('');

  const styleType = _.get(formValues, 'suggestionStyle', '');

  useEffect(() => {
    const productItemTypeValues = _.map(LAYOUT_SUGGESTION_PRODUCT_ITEM_TYPE, item => {
      return { ...item, label: i18n.translate(item.label) };
    });
    const productPositionValues = _.map(LAYOUT_SUGGESTION_PRODUCT_POSITION, item => {
      return { ...item, label: i18n.translate(item.label) };
    });
    const productsPerRowStyle2Values = _.map(LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE2, item => {
      return { ...item, label: i18n.translate(item.label) };
    });
    const productsPerRowStyle3Values = _.map(LAYOUT_SUGGESTION_PRODUCTS_PER_ROW_STYLE3, item => {
      return { ...item, label: i18n.translate(item.label) };
    });
    setProductsItemType(productItemTypeValues);
    setProductsPosition(productPositionValues);
    setProductsPerRowStyle2(productsPerRowStyle2Values);
    setProductsPerRowStyle3(productsPerRowStyle3Values);
  }, []);

  useEffect(() => {
    if (!_.isEmpty(styleType)) setStyleChange(styleType);
  }, [styleType]);

  const handleChangeStyle = value => {
    const products = _.find(suggestionBlocks, item => item.type === 'products');
    const status = products.status;
    if (status === 'disabled' && value !== 'style1') {
      setActiveModalConfirm(true);
    } else {
      updateField('suggestionStyle', value);
    }
  };

  // Handle disable product
  const handleContinueTurnOnProducts = () => {
    const index = _.findIndex(suggestionBlocks, item => item.type === 'products');
    if (index !== -1) {
      updateField(`suggestionBlocks[${index}].status`, 'active');
      updateField('suggestionStyle', styleChange);
    }
    setActiveModalConfirm(false);
  };

  return (
    <div className="layoutSettings">
      <Card
        title={
          <div>
            <span className="headingText">
              {i18n.translate('AdminHTML.InstantSearchDisplay.LayoutSettings.title')}
            </span>
            <div>
              <span className="titleMetadata">
                <a href={URL['InstantSearchDisplayDoc']} target="_blank" rel="noopener noreferrer">
                  <Icon source={QuestionMarkMajor} color="base" />
                </a>
              </span>
              <span className="titleMetadata">
                <button onClick={() => setYoutubeModal(true)}>
                  <Icon source={PlayCircleMajor} color="base" />
                </button>
              </span>
            </div>
          </div>
        }>
        <Card.Section>
          <div className="styleBox">
            <div className={`${styleChange === 'style2' ? `layout-selected` : ''}`}>
              <Card sectioned>
                <div className="box">
                  <div className="layout-image">
                    <img
                      src={getLayoutSettingsImage(
                        'style2',
                        suggestionStyle2ProductItemType,
                        suggestionStyle2ProductPosition,
                        suggestionStyle2ProductPerRow
                      )}
                      alt={i18n.translate('AdminHTML.Analytics.Settings.ignoreIpsList_ImageAlt')}
                    />
                  </div>
                  <div className="layout-settings">
                    <Field
                      name="suggestionStyle"
                      id="style2"
                      component={RenderSuggestionStyle}
                      label={i18n.translate(LAYOUT_SUGGESTION_STYLE_LABEL['style2'])}
                      onChangeValue={value => handleChangeStyle(value)}
                    />
                    <Field
                      name="suggestionStyle2ProductItemType"
                      component={RenderSelect}
                      options={productsItemType}
                    />
                    <Field
                      name="suggestionStyle2ProductPosition"
                      component={RenderSelect}
                      options={productsPosition}
                    />
                    {suggestionStyle2ProductItemType === 'list' && (
                      <Field
                        name="suggestionStyle2ProductPerRow"
                        component={RenderSelect}
                        options={productsPerRowStyle2}
                      />
                    )}
                  </div>
                </div>
              </Card>
            </div>
            <div className={`${styleChange === 'style3' ? `layout-selected` : ''}`}>
              <Card sectioned>
                <div className="box">
                  <div className="layout-image">
                    <img
                      src={getLayoutSettingsImage(
                        'style3',
                        suggestionStyle3ProductItemType,
                        suggestionStyle3ProductPosition,
                        suggestionStyle3ProductPerRow
                      )}
                      alt={i18n.translate('AdminHTML.Analytics.Settings.ignoreIpsList_ImageAlt')}
                    />
                  </div>
                  <div className="layout-settings">
                    <Field
                      name="suggestionStyle"
                      id="style3"
                      component={RenderSuggestionStyle}
                      label={i18n.translate(LAYOUT_SUGGESTION_STYLE_LABEL['style3'])}
                      onChangeValue={value => handleChangeStyle(value)}
                    />
                    <Field
                      name="suggestionStyle3ProductItemType"
                      component={RenderSelect}
                      options={productsItemType}
                    />
                    <Field
                      name="suggestionStyle3ProductPosition"
                      component={RenderSelect}
                      options={productsPosition}
                    />
                    {suggestionStyle3ProductItemType === 'list' && (
                      <Field
                        name="suggestionStyle3ProductPerRow"
                        component={RenderSelect}
                        options={productsPerRowStyle3}
                      />
                    )}
                  </div>
                </div>
              </Card>
            </div>
            <div className={`${styleChange === 'style1' ? 'layout-selected' : ''}`}>
              <Card sectioned>
                <div className="box">
                  <div className="layout-image">
                    <img
                      src={getLayoutSettingsImage('style1', suggestionStyle1ProductItemType)}
                      alt={i18n.translate('AdminHTML.Analytics.Settings.ignoreIpsList_ImageAlt')}
                    />
                  </div>
                  <div className="layout-settings">
                    <Field
                      name="suggestionStyle"
                      id="style1"
                      component={RenderSuggestionStyle}
                      label={i18n.translate(LAYOUT_SUGGESTION_STYLE_LABEL['style1'])}
                      onChangeValue={value => handleChangeStyle(value)}
                    />
                    <Field
                      name="suggestionStyle1ProductItemType"
                      component={RenderSelect}
                      options={productsItemType}
                    />
                  </div>
                </div>
              </Card>
            </div>
          </div>
        </Card.Section>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['InstantSearchDisplay_LayoutSettingsTut']}
          title={i18n.translate('AdminHTML.InstantSearchDisplay.LayoutSettings.youtubeModal_Title')}
          onClose={() => setYoutubeModal(false)}
        />
        {/* Confirm enable modal */}
        <ConfirmModal
          active={activeModalConfirm}
          handleContinue={handleContinueTurnOnProducts}
          handleCancel={() => setActiveModalConfirm(false)}
          title={i18n.translate('AdminHTML.InstantSearchDisplay.ConfirmModal.enableProducts_Title')}
          content={i18n.translate(
            'AdminHTML.InstantSearchDisplay.ConfirmModal.enableProducts_Content'
          )}
          actionLabel={i18n.translate(
            'AdminHTML.InstantSearchDisplay.ConfirmModal.enableProducts_Action'
          )}
          actionDestructive={false}
        />
      </Card>
    </div>
  );
};

export default withI18n()(LayoutSettings);
